// extracted by mini-css-extract-plugin
export default {"title":"SettingsSecurityPassword_title__dg6R5","button":"SettingsSecurityPassword_button__YiLW5"};